import type { WaapHost } from './host';
import { createWaapRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes and catalog scope (plain data; the
 * console stays a lazy chunk behind `route.ts`). The host is a lazy factory, not a value: the app
 * file that builds it imports hooks and dialogs the entry chunk does not need, so it is fetched
 * when a route loads and registered before any code of the console runs. Taking it is the only
 * way to get the routes, so the app cannot mount the module and forget what it reads.
 */
export function createWaapModule(loadHost: () => Promise<WaapHost>) {
  return { servicesRoutes: createWaapRoutes(loadHost), serviceScopes };
}

export type { WaapHost } from './host';
